import { Entry } from 'types';

const FIXED_RETURN_QUANTITY = 1;

export function parseToReturnEntry(entry: Entry) {
  const parsedEntry = structuredClone(entry);

  parsedEntry.quantity = FIXED_RETURN_QUANTITY;
  parsedEntry.priceWithDistributedDiscountPrice =
    entry.unitPriceWithDistributedDiscountPrice;

  return parsedEntry;
}
